import { print } from 'graphql/language/printer';
import { gql } from 'apollo-boost';

const MODULUS_CHECK_QUERY = gql`
  query ModulusCheck($request : ModulusCheckRequestType!){
    modulusCheck(request:$request) {
      valid
    }
  }
`;

const modulusCheck = (/** @type {string } */ accountNumber, /** @type {string } */ sortCode) => 
  new Promise((resolve, reject) => {
    fetch('/graphql', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        query: print(MODULUS_CHECK_QUERY),
        variables: {
          request: {
            accountNumber: accountNumber,
            sortCode: sortCode
          }
        }
      }),
    }).then(response => {
      if (response.status === 200) {
        response.json().then(resultBody => {
          resolve(resultBody.data.modulusCheck.valid);
        }).catch(error => {
          reject(error);
        });
      } else {
        resolve(true);
      }
    }).catch(error => {
      reject(error);
    });
  });


export default modulusCheck;